<template>
  <!--股权冻结-->
  <TableView
    :columns="columns"
    :data="data"
    :pagination="false"
    :loading="loading"
    :bordered="bordered"
    :scroll="scroll"
    :rowKey="rowKey"
  ></TableView>
</template>
<script>
import { TableView } from '@/lxfintech-fe-components'
export default {
  props: ['data'],
  components: { TableView },
  data() {
    return {
      rowKey: 'id',
      scroll: { x: 1300 },
      columns: [
        {
          title: '序号',
          width: 100,
          dataIndex: 'order',
          key: 'order',
          fixed: 'left',
          customRender: (text, record, index) => {
            return index + 1
          },
        },
        {
          title: '被执行人',
          dataIndex: 'personSubjectToEnforcement',
          key: 'personSubjectToEnforcement',
        },
        {
          title: '股权数额',
          dataIndex: 'amount',
          key: 'amount',
        },
        {
          title: '执行法院',
          dataIndex: 'courtOfExecution',
          key: 'courtOfExecution',
        },
        {
          title: '执行通知书文号',
          dataIndex: 'documentNumberOfNotice',
          key: 'documentNumberOfNotice',
        },
        {
          title: '类型/状态',
          dataIndex: 'status',
          key: 'status',
        },
        {
          title: '公示日期',
          dataIndex: 'publicityDate',
          key: 'publicityDate',
        },
      ],
      loading: false,
      bordered: true,
    }
  },
  methods: {},
}
</script>
